import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const FAQ = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div
      className="faq-page py-5"
      style={{
        background: "linear-gradient(135deg, #e6ffe6, #f9fff9)",
        minHeight: "100vh",
      }}
    >
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-down">
          <h1 className="fw-bold text-success">Frequently Asked Questions</h1>
          <p className="text-muted">
            Have questions? We’ve got answers! 🌿
          </p>
        </div>

        <div className="accordion shadow-lg rounded-4" id="faqAccordion" data-aos="fade-up">
          
          {/* Question 1 */}
          <div className="accordion-item border-0 mb-3 shadow-sm rounded-3">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button fw-bold text-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                1. What is RoupanNaturals?
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                RoupanNaturals is a brand dedicated to providing <b>100% natural,
                herbal, and eco-friendly products</b> that promote health, wellness,
                and sustainability.
              </div>
            </div>
          </div>

          {/* Question 2 */}
          <div className="accordion-item border-0 mb-3 shadow-sm rounded-3">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed fw-bold text-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                2. Do you use chemicals or preservatives?
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                No. All our products are <b>free from harmful chemicals, parabens, and preservatives</b>. 
                We use natural ingredients only.
              </div>
            </div>
          </div>

          {/* Question 3 */}
          <div className="accordion-item border-0 mb-3 shadow-sm rounded-3">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed fw-bold text-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                3. How long does shipping take?
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                Shipping usually takes <b>3-7 business days</b> depending on your location.
                Metro cities get faster delivery compared to remote areas.
              </div>
            </div>
          </div>

          {/* Question 4 */}
          <div className="accordion-item border-0 mb-3 shadow-sm rounded-3">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button collapsed fw-bold text-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                4. What payment methods do you accept?
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                We accept <b>UPI, Net Banking, Credit/Debit Cards, and Wallet Payments</b>.
                Cash on Delivery (COD) is also available in selected locations.
              </div>
            </div>
          </div>

          {/* Question 5 */}
          <div className="accordion-item border-0 mb-3 shadow-sm rounded-3">
            <h2 className="accordion-header" id="headingFive">
              <button
                className="accordion-button collapsed fw-bold text-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                5. How can I contact customer support?
              </button>
            </h2>
            <div
              id="collapseFive"
              className="accordion-collapse collapse"
              aria-labelledby="headingFive"
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                You can reach us via:
                <ul>
                  <li><b>Email:</b> support@roupannaturals.com</li>
                  <li><b>Phone:</b> +91 98700 72314</li>
                  <li><b>Instagram DM:</b> @RoupanNaturals</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
